import { Box, Icon, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import cn from 'classnames'

import i18n from 'modules/core/lib/i18n'

import styles from 'modules/billing/components/FeatureCompareTable/index.module.css'

const CheckOrText = ({ property }: { property: string | boolean }) => {
  if (typeof property === 'boolean') {
    return (
      <span>
        <Box alignItems="center">
          <Icon.Medium
            icon={property ? 'check-circle-line' : 'cross-circle'}
            color={property ? 'viridian1000' : 'grey600'}
          />
        </Box>
      </span>
    )
  }

  return <span className={cn(styles.checkText)}>{property}</span>
}

const FeatureText = ({
  title,
  tooltip,
  featureStatus,
}: {
  title: string
  tooltip?: string
  featureStatus?: string
}) => {
  const [open, toggle] = useToggle(false)
  const isNew = featureStatus === 'new'

  if (!tooltip) {
    return <span className={cn(styles.checkText)}>{title}</span>
  }

  return (
    <Tooltip.Alt
      label={tooltip}
      attachment="bottom center"
      targetAttachment="top center"
      size="small"
      open={open}
      toggle={toggle}
    >
      <>
        <span className={cn(styles.checkText, styles.checkTextWithToolTip)}>{title}</span>
        {featureStatus && (
          <div className={styles.featureTag}>
            <Tag inline type={isNew ? 'viridian' : 'neutral'}>
              <Text.Normal size="100">
                {isNew
                  ? i18n.t('pricing_plans.comparison_table.tags.new')
                  : i18n.t('pricing_plans.comparison_table.tags.coming_soon')}
              </Text.Normal>
            </Tag>
          </div>
        )}
      </>
    </Tooltip.Alt>
  )
}

type Props = {
  title: string
  business: string | boolean
  enterprise: string | boolean
  featureStatus?: string
  tooltip?: string
}

const FeatureRow = ({ title, tooltip, featureStatus, business, enterprise }: Props) => {
  return (
    <>
      <td className="border-r">
        <FeatureText title={title} tooltip={tooltip} featureStatus={featureStatus} />
      </td>
      <td className="border-r text-center md:w-1/4 w-1/3">
        <CheckOrText property={business} />
      </td>
      <td className="text-center md:w-1/4 w-1/3">
        <CheckOrText property={enterprise} />
      </td>
    </>
  )
}

export default FeatureRow
